import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Button from 'components/FormUI/Button';

const StyledButtonContainer = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: ${({ backButtonTitle }) => (backButtonTitle ? 'space-between' : 'flex-end')};

  @media (max-width: 425px) {
    flex-direction: column-reverse;
    gap: 20px;
    & > div {
      display: flex;
      flex-direction: column-reverse;
      gap: 20px;
      button {
        min-width: 100%;
      }
    }
  }
`;

const Buttons = ({
  formId,
  disabled,
  backButtonTitle,
  nextButtonTitle,
  backClickHandler,
  onNextClickHandler,
  clientPreviewBtn = false,
  onClientPreviewBtnHandler = () => {},
}) => {
  return (
    <StyledButtonContainer backButtonTitle={backButtonTitle}>
      {backButtonTitle && (
        <>
          <Button invert autoWidth type="button" onClick={backClickHandler}>
            {backButtonTitle}
          </Button>
        </>
      )}
      <div>
        {clientPreviewBtn && (
          <Button autoWidth clientPreviewBtn onClick={onClientPreviewBtnHandler}>
            Client Preview
          </Button>
        )}
        <Button autoWidth type="submit" form={formId} disabled={disabled} onClick={onNextClickHandler}>
          {nextButtonTitle}
        </Button>
      </div>
    </StyledButtonContainer>
  );
};

Buttons.propTypes = {
  disabled: PropTypes.bool,
  formId: PropTypes.string.isRequired,
  backButtonTitle: PropTypes.string,
  nextButtonTitle: PropTypes.string,
  backClickHandler: PropTypes.func,
  onNextClickHandler: PropTypes.func,
};

Buttons.defaultProps = {
  disabled: false,
  backButtonTitle: null,
  nextButtonTitle: null,
  backClickHandler: () => {},
  onNextClickHandler: undefined,
};

export default Buttons;
